export enum Environments {
    LOCAL = "l",
    DEVELOPMENT = "d",
    TEST = "t",
    PREPROD = "r",
    PRODUCTION = "p",
    O = "o",
    PERFTEST = "f"
}